import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '@/app/providers/AuthProvider';
import { ROUTES } from '@/constants/routes';
import { SignInForm } from '@/features/authentication/SignInForm';
import { AuthenticationLayout } from '@/layouts/AuthenticationLayout';

function SignInPage() {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') void navigate({ to: ROUTES.dashboard, replace: true });
  }, [navigate, status]);

  return (
    <AuthenticationLayout title="Sign In" description="Access the PipeMitra administration portal.">
      <SignInForm />
    </AuthenticationLayout>
  );
}

export const Route = createFileRoute('/admin/sign-in')({
  component: SignInPage,
});
